<template>
  <v-container class='pa-2'>
      <div class="nodes-map">
        <LMap
          :zoom="mapZoom"
          :center="[mapMarker.lat, mapMarker.lng]"
          ref="map"
        >
          <LTileLayer :url="url"></LTileLayer>
          <LMarker :lat-lng="mapMarker"></LMarker>
        </LMap>
      </div>
  </v-container>
</template>
      
<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  props: {
    mapZoom: {
      type: Number,
      required: true,
    },
    mapMarker: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
    };
  },
  methods: {},
  watch: {
    mapMarker: {
      handler() {
        console.log("mapMarker has changed!");
        this.$refs.map.mapObject.invalidateSize();
      },
      deep: true,
    },
  },
  mounted() {
    console.log("map mounted");
    console.log(this.mapMarker);
    this.$refs.map.mapObject.invalidateSize();
  },
};
</script>

<style lang="scss" scoped>
.nodes-map {
  height: 600px;
  width: 800px;
  z-index: 0;
}
</style>